<div class="table-striped">
    <mat-form-field *ngIf="isFilterAvailable" style="width: 94%; margin-left: 3%; padding-top: 10px;" appearance="outline">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium">
    </mat-form-field>
    <table mat-table [dataSource]="tableDataSrc" aria-describedby="showSearch" class="w-100" multiTemplateDataRows>
        <ng-container *ngFor="let column of tableColumnsData; index as i" [matColumnDef]="displayColumns[i]">

            <th scope="col" mat-header-cell *matHeaderCellDef>
                <span [innerHtml]="column.columnName"></span>
            </th>

            <td mat-cell *matCellDef="let element">

                <span
                [innerHtml]="element[column.dbColumnName]"></span>

            </td>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>

    </table>
    <mat-paginator [pageSizeOptions]="[10]" showFirstLastButtons>
    </mat-paginator>
</div>